import Spinner from "../../../Components/spinner";
import CustomPagination from "../../../helper/Pagination";
import { ActionButton } from "../../../helper/ImageFormat";
import dateformate from "../../../helper/DateFormate";
const PermissionTable = ({
 loading,
 permission,
 currentPage,
 perPage,
 handleEditClick,
 handleDelete,
 totalCount,
 totalPages,
 handlePageClick,
}) => {
 

 return (
  <div className="row ">
   <div className="col-md-12 grid-margin stretch-card">
    <div className="card">
     <div className="card-body">
      <div className="table-responsive">
       <table
        className=" custom-table table table-striped"
        id="myTable"
        style={{ marginTop: "3px" }}
       >
        <thead>
         <tr>
          <th>Role</th>
          <th>Page Name</th>
          <th>Action Permisssion</th>
          <th>Updated At</th>
          <th>Action</th>
         </tr>
        </thead>
        <tbody>
         {loading ? (
          <tr>
           <td colSpan="12" className="text-center">
            <Spinner />
           </td>
          </tr>
         ) : permission.length > 0 ? (
          permission.map((data, id) => (
           <tr key={data.id}> 
            <td>{data.roleName}</td>
            <td>{data?.pageName}</td>

            <td>
  <div style={{ display: "flex", flexWrap: "wrap", gap: "6px" }}>
    {data?.actions?.map((item, index) => {
      const actionClass = item.toLowerCase().replace(" ", "-");
      return (
        <span
          key={index}
          className={`custom-status-badge badge-${actionClass}`}
        >
          {item}
        </span>
      );
    })}
  </div>
</td>
            <td>{dateformate(data.updatedAt)}</td>
            <td>
             <ActionButton
              data={data}
              handleEditClick={handleEditClick}
              handleDelete={handleDelete}
              module={"Permission"}
             />
            </td>
           </tr>
          ))
         ) : (
          <tr>
           <td colSpan="7" className="text-center">
            <h4>No data available</h4>
           </td>
          </tr>
         )}
        </tbody>
       </table>
      </div>
      {permission?.length > 0 && (
       <div>
        <CustomPagination
         currentPage={currentPage}
         totalPages={totalPages}
         onPageChange={handlePageClick}
         perPage={perPage}
         totalCount={totalCount}
         module={"Permission"}
        />
       </div>
      )}
     </div>
    </div>
   </div>
  </div>
 );
};

export default PermissionTable;
